import { Action } from '@zaibot/fsa';
import { IQuestionDB } from '../../../types';

export default Action<{saveitem: IQuestionDB}>('QUESTION_SAVE');



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/action/QUESTION_SAVE.tsx